/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1sKx9ffix1qWmdscEUQHh6
// Component: 61rgnG3wL1HW
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  useTrigger
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ButtonNav from "../../ButtonNav"; // plasmic-import: WzCWRCw5Fj7M/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/projectcss
import sty from "./PlasmicModuleNavLogo.module.css"; // plasmic-import: 61rgnG3wL1HW/css
import image32NVfzwUwfAUcW from "./images/image32.svg"; // plasmic-import: nVfzwUwfAUcW/picture
import image2OMh955C2SHw from "./images/image2.svg"; // plasmic-import: o-Mh955C2SHw/picture

createPlasmicElementProxy;

export const PlasmicModuleNavLogo__VariantProps = new Array();

export const PlasmicModuleNavLogo__ArgProps = new Array();

const $$ = {};

function PlasmicModuleNavLogo__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const [isRootHover, triggerRootHoverProps] = useTrigger("useHover", {});
  const triggers = {
    hover_root: isRootHover
  };
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root
      )}
      data-plasmic-trigger-props={[triggerRootHoverProps]}
    >
      <ButtonNav
        data-plasmic-name={"buttonNav"}
        data-plasmic-override={overrides.buttonNav}
        color={"white"}
        iconForButton={
          <PlasmicImg__
            data-plasmic-name={"img"}
            data-plasmic-override={overrides.img}
            alt={""}
            className={classNames(sty.img)}
            displayHeight={"100%"}
            displayMaxHeight={"none"}
            displayMaxWidth={"none"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"100%"}
            loading={"lazy"}
            src={
              triggers.hover_root
                ? {
                    src: image2OMh955C2SHw,
                    fullWidth: 256,
                    fullHeight: 256,
                    aspectRatio: 1
                  }
                : {
                    src: image32NVfzwUwfAUcW,
                    fullWidth: 28,
                    fullHeight: 28,
                    aspectRatio: undefined
                  }
            }
          />
        }
        onClick={async () => {
          const $steps = {};
          $steps["goToHttpsO21PCom"] = true
            ? (() => {
                const actionArgs = { destination: "https://o21p.com/" };
                return (({ destination }) => {
                  if (
                    typeof destination === "string" &&
                    destination.startsWith("#")
                  ) {
                    document
                      .getElementById(destination.substr(1))
                      .scrollIntoView({ behavior: "smooth" });
                  } else {
                    location.assign(destination);
                  }
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["goToHttpsO21PCom"] != null &&
            typeof $steps["goToHttpsO21PCom"] === "object" &&
            typeof $steps["goToHttpsO21PCom"].then === "function"
          ) {
            $steps["goToHttpsO21PCom"] = await $steps["goToHttpsO21PCom"];
          }
        }}
        shape={"fullRounding"}
        slotSize={"fillButton"}
        status={"normal"}
      />
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "buttonNav", "img"],
  buttonNav: ["buttonNav", "img"],
  img: ["img"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicModuleNavLogo__ArgProps,
          internalVariantPropNames: PlasmicModuleNavLogo__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicModuleNavLogo__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicModuleNavLogo";
  } else {
    func.displayName = `PlasmicModuleNavLogo.${nodeName}`;
  }
  return func;
}

export const PlasmicModuleNavLogo = Object.assign(
  // Top-level PlasmicModuleNavLogo renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    buttonNav: makeNodeComponent("buttonNav"),
    img: makeNodeComponent("img"),
    // Metadata about props expected for PlasmicModuleNavLogo
    internalVariantProps: PlasmicModuleNavLogo__VariantProps,
    internalArgProps: PlasmicModuleNavLogo__ArgProps
  }
);

export default PlasmicModuleNavLogo;
/* prettier-ignore-end */
